export default function(path = '', name) {
  return path ? path + ',' + name : name;
}